import { ServerConfig } from "@/config/config";
import { CalculatedField } from "@/models/calculated-field";
import { Axios } from "./auth-service";

class CalculatedFieldServiceClass {
	getUrl(dossierId:number, fieldId?:number):string{
		let baseUrl = `${ServerConfig.mainAppHost}/dossier/${dossierId}/calculated-fields`;
		if (fieldId != undefined) {
			return `${baseUrl}/${fieldId}`;
		}
		return baseUrl;
	}

	async getAllFields(dossierId:number):Promise<CalculatedField[]>{
		let result = await Axios.get(this.getUrl(dossierId));
		return ((result.data || []) as any[]).map(d=>new CalculatedField(d));
	}

	async getField(dossierId:number, fieldId:number):Promise<CalculatedField>{
		let result = await Axios.get(this.getUrl(dossierId, fieldId));
		return new CalculatedField(result.data);
	}

	async createField(dossierId:number, field:CalculatedField):Promise<CalculatedField>{
		let result = await Axios.post(this.getUrl(dossierId), field.getJSON());
		return new CalculatedField(result.data);
	}

	async editField(dossierId:number, field:CalculatedField):Promise<CalculatedField>{
		let result = await Axios.put(this.getUrl(dossierId, field.ID), field.getJSON());
		return new CalculatedField(result.data);
	}

	async deleteField(dossierId:number, field:CalculatedField):Promise<void>{
		await Axios.delete(this.getUrl(dossierId, field.ID));
	}
}

export const CalculatedFieldService = new CalculatedFieldServiceClass();